import { Button } from "@swiggy-private/dls-web-core/dist/components/Button";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

export const TitleText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.small,
    paddingRight: "60px",
}));

export const SubText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
    width: "100%",
}));

// The half-card is fixed to bottom:0 and the keyboard overlays the layout viewport (it does not
// resize it), so the CTA/input would sit behind the keyboard. useKeyboardState publishes the
// keyboard height as --ios-keyboard-height (raw px number, reset to 0 on close), so lift the CTA by
// it in addition to the safe-area inset. When the keyboard is closed the var is unset → 0. This is
// the sole lift mechanism for this card (no data-keyboard-scroll / <body> transform), which avoids
// the double-lift + internal scroll the body transform produced.
export const CTA = styled(Button)(({ theme }) => ({
    marginBottom: `calc(var(--sab, 0px) + ${theme.spacing.xLarge} + (var(--ios-keyboard-height, 0) * 1px))`,
}));

export const PinInputContainer = styled.div(() => ({
    margin: "60px 0 48px 0",
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
}));
